// import image360 from "./image/360photo.jpg";
// import fabLab360 from "./image/FabLab_360.jpg";
// import livePoint360 from "./image/LivePoint_360.jpg";
import Paris_Atelier from "./image/360/Paris/Atelier/Atelier Paris VR.jpg";

import Paris_Livepoint_Entrance from "./image/360/Paris/Livepoint/Livepoint Paris 360 entrance.jpg";
import Paris_Livepoint_Center from "./image/360/Paris/Livepoint/Livepoint Paris 360 center.jpg";
import Paris_Livepoint_Fablab from "./image/360/Paris/Livepoint/Livepoint Paris 360 fablab.jpg";
import Paris_Livepoint_Lego from "./image/360/Paris/Livepoint/Livepoint Paris 360 lego.jpg";
import Paris_Livepoint_PingPong from "./image/360/Paris/Livepoint/Livepoint Paris 360 ping pong.jpg";

import Paris_Eylau_Pepiniere from "./image/360/Paris/Eylau/pepiniere.jpg";
import Paris_Eylau_Livepoint from "./image/360/Paris/Eylau/Livepoint.jpg";
import Paris_Eylau_LaSuite from "./image/360/Paris/Eylau/LaSuite.jpg";
import Paris_Eylau_Auditorium from "./image/360/Paris/Eylau/Auditorium.jpg";
import Paris_Eylau_Patio from "./image/360/Paris/Eylau/Patio.jpg";
import Paris_Eylau_LaSuite_MettingRoom from "./image/360/Paris/Eylau/LaSuiteMettingRoom.jpg";

import Nantes_Livepoint from "./image/360/Nantes/Toulouse Cam 360 02 rendu.jpg";
import Nantes_Manufacture_Home from "./image/360/Nantes/Manufacture/Manufacture Nantes 360 Home.jpg";
import Nantes_Manufacture_Floor from "./image/360/Nantes/Manufacture/Manufacture Nantes 360 Floor.jpg";

import Nantes_Medialab from "./image/360/Nantes/Medialab/Medialab.jpg";

import Toulouse_01 from "./image/360/Toulouse/Toulouse CAM 01 360.jpg";
import Toulouse_02 from "./image/360/Toulouse/Toulouse Cam 02 360.jpg";
import Toulouse_03 from "./image/360/Toulouse/Toulouse cam bar 360.jpg";

import Aix_FabLab from "./image/360/Aix/FabLab.jpg";
import Aix_Livepoint from "./image/360/Aix/AixLivepoint.jpg";

/**
** If [visible] is set to true, it will be displayed in the navbar
** [poi] stands for 'pointsOfInterest': it contains all the clickable popups and their coordinates
** [directLinks] contains all the redirections possible via this location: 	
**		it contains the name of the next place and the coordinates of the button
*/
const navItems = [
	{
		name: 'Paris_Eylau_Pepiniere', path: '/Paris_Eylau_Pepiniere', selected: false, img: Paris_Eylau_Pepiniere, visible: true,
		defaultOrientation: 6.5,
		poi: [
			// { name: 'CocoJojo', coords: { angle: -470, height: 0 } }
		],
		directLinks: [
			// { name: 'Accueil 3', path: '/Accueil3', coords: { angle: -348.5, height: 0 } }
		]
	},
	{
		name: 'Paris_Eylau_Livepoint', path: '/Paris_Eylau_Livepoint', selected: false, img: Paris_Eylau_Livepoint, visible: true,
		defaultOrientation: 6.5,
		poi: [
			// { name: 'CocoJojo', coords: { angle: -470, height: 0 } }
		],
		directLinks: [
			// { name: 'Accueil 3', path: '/Accueil3', coords: { angle: -348.5, height: 0 } }
		]
	},
	{
		name: 'Paris_Eylau_LaSuite', path: '/Paris_Eylau_LaSuite', selected: false, img: Paris_Eylau_LaSuite, visible: true,
		defaultOrientation: 5.5,
		poi: [
		],
		directLinks: [
			{ name: 'Paris_Eylau_LaSuite_MettingRoom', coords: { angle: 1.78, height:-40 }, orientation: 6.0 },
		]
	},
	{
		name: 'Paris_Eylau_LaSuite_MettingRoom', path: '/Paris_Eylau_LaSuite_MettingRoom', selected: false, img: Paris_Eylau_LaSuite_MettingRoom, visible: true,
		defaultOrientation: 0,
		poi: [],
		directLinks: [
			{ name: 'Paris_Eylau_LaSuite', coords: { angle: 1.82, height:-80 }, orientation: -0.8 },
		]
	},
	{
		name: 'Paris_Eylau_Auditorium', path: '/Paris_Eylau_Auditorium', selected: false, img: Paris_Eylau_Auditorium, visible: true,
		defaultOrientation: 6.7,
		poi: [
		],
		directLinks: [
			{ name: 'Paris_Eylau_Patio', coords: { angle: -3.0, height: -40 }, orientation: 6.5 }
		]
	},
	{
		name: 'Paris_Eylau_Patio', path: '/Paris_Eylau_Patio', selected: false, img: Paris_Eylau_Patio, visible: true,
		defaultOrientation: 6,
		poi: [
		],
		directLinks: [
			{ name: 'Paris_Eylau_Auditorium', coords: { angle: -1.9, height: -10 }, orientation: 1.4 }
		]
	},

	// =====================================================================================================================================================
	{
		name: 'Paris_Atelier', path: '/Paris_Atelier', selected: false, img: Paris_Atelier, visible: true,
		defaultOrientation: 4.5,
		poi: [
			// { name: 'CocoJojo', coords: { angle: -470, height: 0 } }
		],
		directLinks: [
			// { name: 'Accueil 3', path: '/Accueil3', coords: { angle: -348.5, height: 0 } }
		]
	},
// =====================================================================================================================================================
	{
		name: 'Paris_Livepoint_Entrance', path: '/Paris_Livepoint_Entrance', selected: false, img: Paris_Livepoint_Entrance, visible: true,
		defaultOrientation: 6.2,
		poi: [
			// { name: '', coords: { angle: 0, height: 0 } }
		],
		directLinks: [
			{ name: 'Paris_Livepoint_Center', coords: { angle: -1.3, height:0 }, orientation: 5.0 },
			{ name: 'Paris_Livepoint_Fablab', coords: { angle: -1.5, height:0 }, orientation: 3.9 },
			{ name: 'Paris_Livepoint_PingPong', coords: { angle: -1.5, height:60 }, orientation: 0.0 },
		]
	},
	{
		name: 'Paris_Livepoint_Center', path: '/Paris_Livepoint_Center', selected: false, img: Paris_Livepoint_Center, visible: true,
		defaultOrientation: 0,
		poi: [
			// { name: '', coords: { angle: 0, height: 0 } }
		],
		directLinks: [
			{ name: 'Paris_Livepoint_PingPong', coords: { angle: 0, height:120 }, orientation: 0.0 },
			{ name: 'Paris_Livepoint_Entrance', coords: { angle: 3.5, height:0 }, orientation: 6.2 },
			{ name: 'Paris_Livepoint_Lego', coords: { angle: 3, height:120 }, orientation: 0.0 },
			{ name: 'Paris_Livepoint_Fablab', coords: { angle: 0, height: 0 }, orientation: 3.9 }
		]
	},
	{
		name: 'Paris_Livepoint_Fablab', path: '/Paris_Livepoint_Fablab', selected: true, img: Paris_Livepoint_Fablab, visible: true,
		defaultOrientation: 0,
		poi: [
			// { name: '', coords: { angle: 0, height: 0 } }
		],
		directLinks: [
			{ name: 'Paris_Livepoint_Center', coords: { angle: 0.9, height:-0 }, orientation: 1.5 },
			{ name: 'Paris_Livepoint_Entrance', coords: { angle: 1.2, height:0 }, orientation: 6.2 },
			{ name: 'Paris_Livepoint_Lego', coords: { angle: 0.9, height:80 }, orientation: 0.0 },
		]
	},
	{
		name: 'Paris_Livepoint_Lego', path: '/Paris_Livepoint_Lego', selected: false, img: Paris_Livepoint_Lego, visible: true,
		defaultOrientation: 0,
		poi: [
			// { name: '', coords: { angle: 0, height: 0 } }
		],
		directLinks: [
			{ name: 'Paris_Livepoint_Center', coords: { angle: -1.6, height:-150 }, orientation: 5.0 },
			{ name: 'Paris_Livepoint_Fablab', coords: { angle: -1.6, height:-80 }, orientation: 3.9 },
			{ name: 'Paris_Livepoint_PingPong', coords: { angle: -1.6, height:0 }, orientation: 0.0 },
		]
	},
	{
		name: 'Paris_Livepoint_PingPong', path: '/Paris_Livepoint_PingPong', selected: false, img: Paris_Livepoint_PingPong, visible: true,
		defaultOrientation: 0,
		poi: [
			// { name: '', coords: { angle: 0, height: 0 } }
		],
		directLinks: [
			{ name: 'Paris_Livepoint_Center', coords: { angle: -1.6, height:-150 }, orientation: 1.5 },
			{ name: 'Paris_Livepoint_Entrance', coords: { angle: -1.35, height:-90 }, orientation: 6.2 },
			{ name: 'Paris_Livepoint_Lego', coords: { angle: -1.6, height:0 }, orientation: 0.0 },
		]
	},
// =====================================================================================================================================================
	{
		name: 'Nantes_Livepoint', path: '/Nantes_Livepoint', selected: false, img: Nantes_Livepoint, visible: true,
		defaultOrientation: 0,
		poi: [
			// { name: '', coords: { angle: 0, height: 0 } }
		],
		directLinks: [
			// { name: 'Centre', coords: { angle: -470, height: 0 } },
		]
	},
// =====================================================================================================================================================
	{
		name: 'Nantes_Manufacture', path: '/Nantes_Manufacture', selected: false, img: Nantes_Manufacture_Home, visible: true,
		defaultOrientation: 0,
		poi: [
			// { name: '', coords: { angle: 0, height: 0 } }
		],
		directLinks: [
			{ name: 'Nantes_Manufacture_Floor', coords: { angle: -1.6, height:110 }, orientation: 0.0 },
		]
	},
	{
		name: 'Nantes_Manufacture_Floor', path: '/Nantes_Manufacture_Floor', selected: false, img: Nantes_Manufacture_Floor, visible: true,
		defaultOrientation: 0,
		poi: [
			// { name: '', coords: { angle: 0, height: 0 } }
		],
		directLinks: [
			{ name: 'Nantes_Manufacture', coords: { angle: -1.58, height:-70 }, orientation: 0.0 },
		]
	},
// =====================================================================================================================================================
	{
		name: 'Nantes_Medialab', path: '/Nantes_Medialab', selected: false, img: Nantes_Medialab, visible: true,
		defaultOrientation: 0,
		poi: [
			// { name: '', coords: { angle: 0, height: 0 } }
		],
		directLinks: [
		]
	},
// =====================================================================================================================================================
	{
		name: 'Toulouse_01', path: '/Toulouse_01', selected: false, img: Toulouse_01, visible: true,
		defaultOrientation: 0.8,
		poi: [
			// { name: '', coords: { angle: 0, height: 0 } }
		],
		directLinks: [
			{ name: 'Toulouse_02', coords: { angle: -2.0, height:0 }, orientation: 0 },
			{ name: 'Toulouse_03', coords: { angle: 3.5 , height:0 }, orientation: 3.5 },
		]
	},
	{
		name: 'Toulouse_02', path: '/Toulouse_02', selected: false, img: Toulouse_02, visible: true,
		defaultOrientation: 0,
		poi: [
			// { name: '', coords: { angle: 0, height: 0 } }
		],
		directLinks: [
			{ name: 'Toulouse_01', coords: { angle: -1.5, height:0 }, orientation: 0.8 },
		]
	},
	{
		name: 'Toulouse_03', path: '/Toulouse_03', selected: false, img: Toulouse_03, visible: true,
		defaultOrientation: 0,
		poi: [
			// { name: '', coords: { angle: 0, height: 0 } }
		],
		directLinks: [
			{ name: 'Toulouse_01', coords: { angle: 1, height:0 }, orientation: 0.8 },
		]
	},
	// =====================================================================================================================================================
	{
		name: 'Aix_FabLab', path: '/Aix_FabLab', selected: false, img: Aix_FabLab, visible: true,
		defaultOrientation: 4.8,
		poi: [
			// { name: '', coords: { angle: 0, height: 0 } }
		],
		directLinks: [
			// { name: 'Toulouse_02', coords: { angle: -2.0, height:0 }, orientation: 0 },
			// { name: 'Toulouse_03', coords: { angle: 3.5 , height:0 }, orientation: 3.5 },
		]
	},
	{
		name: 'Aix_Livepoint', path: '/Aix_Livepoint', selected: false, img: Aix_Livepoint, visible: true,
		defaultOrientation: 3.1,
		poi: [
		],
		directLinks: [
		]
	},
]

export default navItems;